export default {
  listaUnidadesAtendimento: [],
  unidadeAtendimento: {
    id: null,
    descricao: '',
    qtdDeSala: null,
    ativo: true,
  },
}
